export default __webpack_public_path__ + "static/media/4852ABEC-6151-4509-B8E4-A894AB55BE0A_1_102_o.4ce8fc5b.jpeg";